import { ICoworking } from '../types/coworking';

export function getCoworkingPageTitle(coworking: ICoworking | null): string {
  const { name } = coworking || {};

  if (!name) {
    return 'Коворкинг';
  }

  return `Коворкинг «${name}»`;
}
